export default __webpack_public_path__ + "static/media/logoPurple.ec4acba5.svg";